<div class="channel-create">
  <lum-channel-form-v2></lum-channel-form-v2>
</div>
